module.exports = __webpack_public_path__ + "static/media/instagram-link.3858cdf8.svg";